import Icon from '../components/Icon.vue'

Icon.register({"undo-alt":{"width":512,"height":512,"paths":[{"d":"M255.5 8C189.3 8.1 129.1 34.2 84.7 76.7L49 41C33.9 25.9 8 36.6 8 57.9V192C8 205.3 18.7 216 32 216H166.1C187.4 216 198.1 190.1 183 175L141.3 133.3C172.1 104.4 212.1 88.4 254.5 88 346.9 87.2 424.8 162 424 257.4 423.2 348 349.8 424 256 424 214.9 424 176 409.3 145.4 382.4 140.6 378.3 133.5 378.5 129 383L89.3 422.7C84.5 427.5 84.7 435.5 89.8 440.1 133.8 479.8 192.1 504 256 504 393 504 504 393 504 256 504 119.2 392.4 7.8 255.5 8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/undo-alt.js
// module id = Cmrc
// module chunks = 0